// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_warningRow__WBl3Z{
    margin-top: 50px;
}
.Table_warningRow__WBl3Z p a{
    color: var(--color-primary);
    font-size: var(--font-size-lg);
    text-decoration: underline;
}
.Table_warningRow__WBl3Z p{
    font-size: var(--font-size-lg);
}
.Table_buttonRow__p0Ef5{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
}
.Table_buttonRow__p0Ef5 p{
    max-width: 635px;
}
.Table_sectionBannerContainer__K9h7y{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1110px;
}
.Table_sectionBanner__R-l0M{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Services/sections/Table/Table.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,0BAA0B;AAC9B;AACA;IACI,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf","sourcesContent":[".warningRow{\n    margin-top: 50px;\n}\n.warningRow p a{\n    color: var(--color-primary);\n    font-size: var(--font-size-lg);\n    text-decoration: underline;\n}\n.warningRow p{\n    font-size: var(--font-size-lg);\n}\n.buttonRow{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 20px;\n}\n.buttonRow p{\n    max-width: 635px;\n}\n.sectionBannerContainer{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 1110px;\n}\n.sectionBanner{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warningRow": `Table_warningRow__WBl3Z`,
	"buttonRow": `Table_buttonRow__p0Ef5`,
	"sectionBannerContainer": `Table_sectionBannerContainer__K9h7y`,
	"sectionBanner": `Table_sectionBanner__R-l0M`
};
export default ___CSS_LOADER_EXPORT___;
